/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Components/AzureSubscriptionManualAuthComponent" />
import * as React from "react";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { TextField } from "VSSUI/TextField";
import { FormItem } from "VSSUI/FormItem";
import { ServiceEndpoint, AzureSubscription } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { ObservableValue } from "VSS/Core/Observable";
import { Environment, AzureRMKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/AzureRMEndpointConstants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorPanelUtils, cloneEndpoint } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { Dropdown } from "VSSUI/Dropdown";
import { IListBoxItem } from "VSSUI/ListBox";
import { InputDetails } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";
import { InputDataType } from "ServiceEndpoints/Client/Contracts/FormInput_ServiceEndpoint";
import { EndpointEditorBaseComponent, IEndpointEditorBaseComponentState, IEndpointEditorBaseComponentProps } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointEditorBaseComponent";
import * as KubernetesEndpointConstants from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/KubernetesEndpointConstants";

export interface IAzureSubscriptionManualAuthComponentProps extends IEndpointEditorBaseComponentProps {
    updateValidAndDirtyStateChange: (isValid?: boolean, isDirty?: boolean) => void;
}

export class AzureSubscriptionManualAuthComponent extends EndpointEditorBaseComponent<IAzureSubscriptionManualAuthComponentProps, IEndpointEditorBaseComponentState>{

    constructor(props: IAzureSubscriptionManualAuthComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._draftServiceEndpoint = cloneEndpoint(this.props.draftEndpoint);
        this._draftServiceEndpoint.authorization.parameters.azureEnvironment = Environment.AZURE_CLOUD;
        if (this._draftServiceEndpoint.url === KubernetesEndpointConstants.AzureCloudUrl)
        {
            this._draftServiceEndpoint.url = "";
        }
        this._inputDetailsList = [
         
            {
                inputId: this._subscriptionId,
                initialValue: props.draftEndpoint.data.azureSubscriptionId,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._subscriptionName,
                initialValue: props.draftEndpoint.data.azureSubscriptionName,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._spnId,
                initialValue: props.draftEndpoint.authorization.parameters.spnId,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._spnKey,
                initialValue: props.draftEndpoint.authorization.parameters.spnKey,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._clusterId,
                initialValue: props.draftEndpoint.data.clusterId,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._namespace,
                initialValue: props.draftEndpoint.data.namespace,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._tenantId,
                initialValue: props.draftEndpoint.authorization.parameters.azureTenantId,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            },
            {
                inputId: this._clusterurl,
                initialValue: props.draftEndpoint.data.url,
                inputValidation: EndpointsEditorPanelUtils.getInputValidation(InputDataType.String, true),
                isConfidential: true,
                isUpdate: this.props.isUpdateForm
            }
        ];
    }

    public componentDidMount() {
        this.addInputs(this._inputDetailsList);
    }

    public componentWillReceiveProps(props: IAzureSubscriptionManualAuthComponentProps) {
        this._draftServiceEndpoint = cloneEndpoint(props.draftEndpoint);
    }

    public componentWillUnmount() {
        let currentInputIds: string[] = [];
        this._inputDetailsList.forEach((input) => currentInputIds.push(input.inputId));
        this.removeInputs(currentInputIds);
    }

    public render(): React.ReactNode {
        let subscriptionId: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.data.azureSubscriptionId || "");
        let subscriptionName: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.data.azureSubscriptionName || "");
        let servicePrincipalClientId: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.authorization.parameters.spnId || "");
        let servicePrincipalKey: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.authorization.parameters.spnKey || "");
        let tenantId: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.authorization.parameters.azureTenantId || "");
        let clusterId: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.data.clusterId || "");
        let clusterUrl: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.url || "");
        let clusterNamespace: ObservableValue<string> = new ObservableValue(this._draftServiceEndpoint.data.namespace || "");
        return (
            <React.Fragment>
                <FormItem
                    label={Resources.Environment}
                    className="default-input-margin-top"
                >
                    <Dropdown
                                ariaLabel={Resources.Environment}
                                items={this._getEnvironments()}
                                placeholder={this._draftServiceEndpoint.authorization.parameters.azureEnvironment || Resources.AzureCloud}
                                onSelect={this._environmentChange}
                    />
                </FormItem>
                <FormItem label={Resources.SubscriptionId}
                    className="default-input-margin-top"
                >
                    <TextField value={subscriptionId} 
                        onChange={(event, value) => {
                            subscriptionId.value = value;
                        }} 
                        onBlur={() => {
                            this._onSubscriptionIdChange(subscriptionId.value);
                        }} 
                    />
                </FormItem>
                <FormItem label={Resources.SubscriptionName}
                    className="default-input-margin-top"
                >
                    <TextField value={subscriptionName} 
                        onChange={(event, value) => {
                            subscriptionName.value = value;
                        }} 
                        onBlur={() => {
                            this._onSubscriptionNameChange(subscriptionName.value);
                        }} 
                    />
                </FormItem>  
                <FormItem label={Resources.ServicePrincipalClientId}
                    className="default-input-margin-top"
                >
                    <TextField value={servicePrincipalClientId} 
                        onChange={(event, value) => {
                            servicePrincipalClientId.value = value;
                        }} 
                        onBlur={() => {
                            this._onSPNIdChange(servicePrincipalClientId.value);
                        }} 
                    />
                </FormItem>
                <FormItem label={Resources.ServicePrincipalKey}
                    className="default-input-margin-top"
                >
                    <TextField value={servicePrincipalKey} 
                        inputType="password"
                        placeholder={this.props.isUpdateForm ? "******" : ""}
                        onChange={(event, value) => {
                            servicePrincipalKey.value = value;
                        }} 
                        onBlur={() => {
                            this._onSPNKeyChange(servicePrincipalKey.value);
                        }} 
                    />
                </FormItem>
                <FormItem label={Resources.tenantId}
                    className="default-input-margin-top"
                >
                    <TextField value={tenantId} 
                        onChange={(event, value) => {
                            tenantId.value = value;
                        }} 
                        onBlur={() => {
                            this._onTenantIdChange(tenantId.value);
                        }} 
                    />
                </FormItem>  
                <FormItem label={Resources.ClusterId}
                    className="default-input-margin-top"
                >
                    <TextField value={clusterId} 
                        onChange={(event, value) => {
                            clusterId.value = value;
                        }}
                        onBlur={() => {
                            this._onClusterIdChange(clusterId.value);
                        }}  
                    />
                </FormItem>
                <FormItem label={Resources.ClusterUrl}
                    className="default-input-margin-top"
                >
                    <TextField value={clusterUrl} 
                        onChange={(event, value) => {
                            clusterUrl.value = value;
                        }}
                        onBlur={() => {
                            this._onClusterUrlChange(clusterUrl.value);
                        }}  
                    />
                </FormItem>
                <FormItem label={Resources.Namespace}
                    className="default-input-margin-top"
                >
                    <TextField value={clusterNamespace} 
                        onChange={(event, value) => {
                            clusterNamespace.value = value;
                        }}
                        onBlur={() => {
                            this._onNamespaceChange(clusterNamespace.value);
                        }} 
                    />
                </FormItem>
            </React.Fragment>
        );
    } 

    private _getEnvironments(): IListBoxItem[] {
        let options: IListBoxItem[] = [];
        if (options) {
            options.push({id: Environment.AZURE_CLOUD, text: Resources.AzureCloud});
            options.push({id: Environment.AZURE_CHINA_CLOUD, text: Resources.AzureChinaCloud});
            options.push({id: Environment.AZURE_US_GOVERNMENT, text: Resources.AzureUSGovernment});
        }

        return options;
    }

    private _environmentChange = (event: any, selectedOption: IListBoxItem) => {
        this._draftServiceEndpoint.authorization.parameters.azureEnvironment = selectedOption.id;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
    }

    private _onNamespaceChange = (value: any) => {
        this._draftServiceEndpoint.data.namespace = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._namespace, value);
    }

    private _onClusterUrlChange = (value: any) => {
        this._draftServiceEndpoint.url = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._clusterurl, value);
    }

    private _onClusterIdChange = (value: any) => {
        this._draftServiceEndpoint.data.clusterId = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._clusterId, value);
    }

    private _onTenantIdChange = (value: any) => {
        this._draftServiceEndpoint.authorization.parameters.azureTenantId = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._tenantId, value);
    }

    private _onSPNKeyChange = (value: any) => {
        this._draftServiceEndpoint.authorization.parameters.spnKey = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._spnKey, value);
    }

    private _onSPNIdChange = (value: any) => {
        this._draftServiceEndpoint.authorization.parameters.spnId = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._spnId, value);
    }

    private _onSubscriptionNameChange = (value: any) => {
        this._draftServiceEndpoint.data.azureSubscriptionName = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._subscriptionName, value);
    }

    private _onSubscriptionIdChange = (value: any) => {
        this._draftServiceEndpoint.data.azureSubscriptionId = value;
        this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        this.validateInputState(this._subscriptionId, value);
    }

    protected handleValidAndDirtyStateChange(isValid?: boolean, isDirty?: boolean) {
        this.props.updateValidAndDirtyStateChange(isValid, isDirty);
    }

    private _draftServiceEndpoint: ServiceEndpoint;
    private _inputDetailsList: InputDetails[];
    private _subscriptionId = "subscriptionID";
    private _subscriptionName = "subscriptionName";
    private _spnId = "spnId";
    private _spnKey = "spnKey";
    private _tenantId = "tenantId";
    private _clusterId = "clusterid";
    private _namespace = "namespace";
    private _clusterurl = "clusterurl";
}
